import { render, staticRenderFns } from "./jDepot.vue?vue&type=template&id=d0af7612&"
import script from "./jDepot.vue?vue&type=script&lang=js&"
export * from "./jDepot.vue?vue&type=script&lang=js&"
import style0 from "./jDepot.vue?vue&type=style&index=0&id=d0af7612&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports